/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

import { ISpacerProps } from './spacer.props.autogenerated';

export interface ISpacerViewProps extends ISpacerProps<{}> {
    className?: string;
}

/**
 *
 * SpacerModule component.
 * @extends {React.PureComponent<ISpacerProps>}
 */
class Spacer extends React.PureComponent<ISpacerProps<{}>> {
    public render(): JSX.Element | null {
        const { className } = this.props.config;
        const spacerClass = this.props.config.spacerHeight ? `ms-${this.props.config.spacerHeight}` : 'ms-spacer';
        const viewProps = {
            // Context for telemetry and raw data for C1 to do customization
            // Including computed data, state data and methods
            ...this.props,
            className: (className && classnames(spacerClass, className)) || spacerClass
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Spacer;
